var tocList = document.getElementById('toc_js');
var tocTitle = document.querySelectorAll('.article__body.rte h2');

if (tocList != undefined) {
    for (let i = 0; i < tocTitle.length; i++) {
        tocTitle[i].id = tocTitle[i].innerText;
        let listItem = document.createElement('li');
        listItem.id = "tocId";
        var thisList = tocList.appendChild(listItem);
        var thisLi = tocTitle[i];
        addList(thisLi, thisList);
        function addList(title, list) {
            list.innerHTML = "<a href='#" + title.id + "'><span>" + title.innerText + "</span></a>";
        }
    }
} else {
    // don't load the js 
}
